module.exports = __webpack_public_path__ + "img/folder-view.2148a681.png";